@if (settings().label) {
  <label
    uilistlabel
    [label]="settings().label"
    [labelCssClass]="labelCssClass()"
    [labelTip]="settings().labelTip"
  ></label>
}
<div uilistwrapper [class]="wrapperCssClass()">
  @if (uiHeaderTemplate()) {
    <div uilistheader [class]="headerCssClass()">
      <ng-container *ngTemplateOutlet="uiHeaderTemplate()!"></ng-container>
    </div>
  }
  <div
    uilistcontent
    [class]="contentCssClass()"
    cdkDropList
    [cdkDropListData]="plainItems()"
    (cdkDropListDropped)="drop($event)"
  >
    @for (item of plainItems(); track item[settings().itemIdKey] ?? $index) {
      @if (!item[settings().itemDeletedKey]) {
        <div
          uilistitem
          cdkDrag
          [hidden]="item[settings().itemHiddenKey]"
          [attr.uiTag]="settings().itemIdKey + '-' + item[settings().itemIdKey]"
          [cdkDragDisabled]="!reOrdering()"
          [class]="itemCssClass()"
          (click)="onItemClicked(item, $event)"
          (mouseenter)="toggleListItemOptions(item[settings().itemIdKey])"
          (mouseleave)="toggleListItemOptions(item[settings().itemIdKey])"
        >
          @if (reOrdering()) {
            <icon
              uilistreorderhandle
              cdkDragHandle
              [iconDefinition]="ICONS.DRAG_INDICATOR"
            >
            </icon>
          }
          @if (uiItemTemplate()) {
            <ng-container
              *ngTemplateOutlet="
                uiItemTemplate()!;
                context: {
                  $implicit: rawOptionMap.get(item),
                  meta: settings().metaData,
                  index: $index,
                }
              "
            >
            </ng-container>
          } @else {
            {{ item[settings().itemValueKey] }}
          }
          @if (uiItemOptionsTemplate()) {
            <div uilistitemactions [class]="actionCssClass()">
              <ng-container
                *ngTemplateOutlet="
                  uiItemOptionsTemplate()!;
                  context: { $implicit: rawOptionMap.get(item) }
                "
              >
              </ng-container>
            </div>
          }
        </div>
      }
    }
  </div>
</div>
